import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Paths } from "./../../constants/UrlConstants";
import Store from "./../../content/Store";
import Contentify from "../../content/Contentify";

export const NotificationsStatus = ({ notificationCount, content }) => {
  // let viewLink;
  let message = (
    <span id="noNotifications">{content.noNotificationsMessage}</span>
  );
   if (notificationCount) {
  //   viewLink = (
  //     <Link
  //       to={Paths.Notifications}
  //       id="viewLink"
  //       className="float-right hidden-xs-down"
  //       aria-label={content.viewAriaLabel}
  //     >
  //       {content.view}{" "}
  //       <span id="viewNotifications" className="ml-2">
  //         ➔
  //       </span>
  //     </Link>
  //   );
    message = (
      <span id="youHaveNotifications">
        {content.youHave}
        <Link to={Paths.Notifications} id="numberLink">
          {notificationCount}{" "}
          {notificationCount > 1
            ? content.newNotifications
            : content.newNotification}
        </Link>
        {/* <span className="hidden-xs-down">{content.needYourAction}</span> */}
      </span>
    );
  }
  return (
    <React.Fragment>
      <i className="icon-notification" />
      {message}
      {/* {viewLink} */}
    </React.Fragment>
  );
};

NotificationsStatus.content = Store.Notifications;

export const mapStateToNotificationsStatus = (state) => ({
  notificationCount:
    state.notificationsReducer.selectedPolicy &&
    state.notificationsReducer.selectedPolicy.notifications &&
    state.notificationsReducer.selectedPolicy.notifications.length
});

export default connect(mapStateToNotificationsStatus)(
  Contentify(NotificationsStatus)
);
